import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IMenuItem } from "../Menu/IMenuItem";
import { PillSelect } from "../PillSelect";
import * as styles from "./TagSelect.scss";

export interface ITagSelectProps {
    tagKey: string;
    value: string | undefined;
    valueOptions: string[];
    includeNone?: boolean;
    className?: string;
    immutable?: boolean;
    tooltipText?: string;
    disableInheritedTags?: boolean;
    onChange: (key: string, value: string | undefined) => void;
}

@observer
export class TagSelect extends Component<ITagSelectProps> {
    public render() {
        const {
            tagKey,
            value,
            valueOptions,
            includeNone,
            className,
            immutable,
            tooltipText,
        } = this.props;
        const { onSelected } = this;

        const values = [
            ...new Set([
                ...(valueOptions || []),
                ...(value !== undefined ? [value] : []),
            ]),
        ].sort();

        if (tagKey.startsWith("$.")) {
            return false;
        }

        const empty = value === undefined;

        const disabled = empty && !values.length;

        const label = value
            ? `${tagKey}: ${value}`
            : value === ""
              ? `${tagKey}: None`
              : undefined;

        const items = values
            .filter(_ => includeNone || !!_)
            .map<IMenuItem<string>>(tagValue => ({
                value: tagValue,
                label: tagValue === "" ? "None" : undefined,
                className: tagValue === "" ? styles.none : undefined,
                selected: tagValue === value,
                icon: "tags",
                onSelected,
            }));

        return (
            <PillSelect
                title={tagKey}
                label={label}
                items={items}
                empty={empty}
                disabled={disabled}
                className={classnames(styles["tag-select"], className)}
                onClear={this.onClear}
                immutable={immutable}
                tooltipText={tooltipText}
            />
        );
    }

    private onClear = () => {
        const { tagKey: key, onChange } = this.props;
        onChange(key, undefined);
    };

    private onSelected = (tagValue: string) => {
        const { tagKey: key, value, onChange } = this.props;
        onChange(key, tagValue !== value ? tagValue : undefined);
    };
}
